export const deviceSizes = {
  tablet: '(min-width: 768px)',
}
